<template>
  <div class="w-100">
    <v-list
      nav
      density="compact"
      class="pa-0 w-100"
      v-for="(item, index) in localItems"
      :key="index"
    >
      <ui-list-item
        class="ui-card mb-1"
        :icon="IconForFilterList(item.type)"
        :title="stripHtml(item.title) + ' - ' + item.action.type"
        arrow
        @click="internalDialog = true"
      >
      </ui-list-item>
    </v-list>

    <div class="text-right pt-1">
      <v-btn
        color="var(--primary)"
        @click="internalDialog = true"
        variant="text"
        class="btn btn-sm"
        :disabled="!canAddMore"
      >
        <ui-icon name="plus" />
        {{ btnText }}
      </v-btn>
    </div>
    <v-dialog
      v-model="internalDialog"
      class="dialog-right-drawer"
      transition="slide-x-reverse-transition"
      max-width="700px"
      scrollable
      persistent
    >
      <template #default>
        <v-slide-x-reverse-transition>
          <v-card color="#eff3f7" class="canvas-background">
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="ui-h4 text-white">
                {{ $t("action_settings") }}</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-btn
                color="#eff3f7"
                class="btn btn-sm"
                :loading="loading"
                :disabled="loading"
                @click="closeAndUpdatePage"
              >
                {{ $t("save") }}
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <!-- Als er geen acties zijn -->
              <div v-if="localItems.length === 0" class="pa-4">
                <div class="container-sm">
                  <h5 class="text-secondary mb-4">{{ $t("interaction_actions") }}</h5>
                  <v-row dense>
                    <v-col
                      v-for="action in defaultInteractionActions"
                      :key="action.type"
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <v-card
                        class="card k-card-border action-template-card card-sm h-100"
                        @click="addAction(action)"
                      >
                        <div class="mb-2 action-icon">
                          <ui-icon :name="action.icon" :size="24" />
                        </div>
                        <h6 class="ui-h5">{{ action.title }}</h6>
                        <p class="text-secondary">{{ action.description }}</p>
                      </v-card>
                    </v-col>
                  </v-row>

                  <h5 class="text-secondary my-4">{{ $t("data_actions") }}</h5>
                  <v-row dense>
                    <v-col
                      v-for="action in defaultDataActions"
                      :key="action.type"
                      cols="12"
                      md="6"
                      lg="4"
                    >
                      <v-card
                        class="card k-card-border action-template-card card-sm"
                        @click="addAction(action)"
                      >
                        <div class="mb-2 action-icon">
                          <ui-icon :name="action.icon" :size="24" />
                        </div>
                        <h6 class="ui-h5">{{ action.title }}</h6>
                        <p class="text-secondary">{{ action.description }}</p>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="container-sm">
                <div class="condition-main py-10">
                  <draggable
                    :list="localItems"
                    group="actions"
                    :animation="200"
                    :handle="'.drag-btn'"
                    @end="emitUpdate"
                  >
                    <div
                      class="condition-cards"
                      v-for="(item, index) in localItems"
                      :key="index"
                    >
                      <div class="card-group">
                        <div class="ui-card d-flex">
                          <v-btn
                            class="drag-btn ui-btn-icon ui-btn ma-1"
                            color="var(--primary)"
                            size="small"
                            icon
                            variant="text"
                          >
                            <ui-icon name="grip-vertical" />
                          </v-btn>
                          <collapse-section class="w-100" title="Actie" :open="true">
                            <k-field-group :name="$t('title')" labelsize="4">
                              <v-row dense>
                                <v-col cols="9">
                                  <tip-tap-input
                                    v-model="item.title"
                                    :fields="collectionFields"
                                    :error="titleErrors.includes(index)"
                                    :error-messages="
                                      titleErrors.includes(index)
                                        ? ['Titel is verplicht']
                                        : []
                                    "
                                    @update:modelValue="clearTitleError(index)"
                                  />
                                </v-col>
                                <v-col cols="3">
                                  <ui-icon-picker v-model="item.icon" />
                                </v-col>
                              </v-row>
                            </k-field-group>
                            <v-divider class="my-2" />

                            <k-field-group name="Actie" labelsize="4">
                              <action-types
                                class="mb-2"
                                v-model="item.action.type"
                                :fields="collectionFields"
                                @update:modelValue="emitUpdate"
                              />
                            </k-field-group>

                            <div v-if="item.action.type === 'open-url'">
                              <!-- Go to action -->
                              <k-field-group
                                name="Target"
                                labelsize="4"
                                labelcolclass="py-0"
                              >
                                <v-select
                                  class="ui-select"
                                  v-model="item.action.target"
                                  :items="targets_go_to"
                                  item-title="title"
                                  item-value="value"
                                  variant="solo"
                                  hide-details
                                  :menu-props="{ class: 'kyano-menu' }"
                                />
                              </k-field-group>

                              <k-field-group
                                name="URL"
                                labelsize="4"
                                labelcolclass="py-0"
                              >
                                <tip-tap-input
                                  v-model="item.action.url"
                                  :fields="collectionFields"
                                />
                              </k-field-group>
                            </div>
                            <div v-else-if="item.action.type === 'show-form-screen'">
                              <!--  Show form screen -->
                              <k-field-group
                                name="Pagina"
                                labelsize="4"
                                labelcolclass="py-0"
                              >
                                <v-select
                                  class="ui-select"
                                  v-model="item.action.page"
                                  :items="pages"
                                  item-title="title"
                                  item-value="id"
                                  variant="solo"
                                  hide-details
                                  :menu-props="{ class: 'kyano-menu' }"
                                />
                              </k-field-group>
                            </div>

                            <k-field-group
                              v-if="item.action.type === 'copy-clipboard'"
                              name="Data"
                              labelsize="4"
                            >
                              <tip-tap-input
                                v-model="item.action.data"
                                :fields="collectionFields"
                              />
                            </k-field-group>

                            <k-field-group name="Succes bericht" labelsize="4">
                              <v-row dense>
                                <v-col cols="12">
                                  <tip-tap-input
                                    v-model="item.message"
                                    :fields="collectionFields"
                                  />
                                </v-col>
                                <!-- <v-col cols="3">
                                  <ui-icon-picker v-model="item.message_icon" />
                                </v-col> -->
                              </v-row>
                            </k-field-group>

                            <k-field-group
                              :name="$t('collection')"
                              labelsize="4"
                              v-if="
                                ['edit-row', 'add-row', 'delete-row'].includes(
                                  item.action.type
                                )
                              "
                            >
                              <collections-select
                                v-model="item.action.collection"
                                :collections="collections"
                              />
                            </k-field-group>

                            <k-field-group
                              v-if="
                                ['edit-row', 'add-row', 'delete-row'].includes(
                                  item.action.type
                                )
                              "
                              name="Scherm sluiten"
                              labelsize="6"
                            >
                              <div class="ml-auto">
                                <v-switch
                                  v-model="item.action.close_screen"
                                  color="var(--primary)"
                                  hide-details
                                  inset
                                ></v-switch>
                              </div>
                            </k-field-group>
                            <v-divider class="my-2" />

                            <k-field-group
                              name="Weergave voorwaarden"
                              labelsize="6"
                              labelcolclass="mb-auto"
                            >
                              <visibility
                                :v-model="item.conditionString"
                                @input="emitUpdate"
                                btn-text="Conditie toevoegen"
                              />
                            </k-field-group>
                          </collapse-section>
                        </div>
                        <v-btn
                          class="c-delete-btn ui-btn-icon ui-btn"
                          @click="removeRow(index)"
                          color="var(--danger)"
                          size="small"
                          icon
                          variant="text"
                        >
                          <ui-icon name="trash-2" />
                        </v-btn>
                      </div>
                    </div>
                  </draggable>
                  <div class="d-flex justify-space-between pb-15 condition-cards">
                    <v-btn
                      color="var(--primary)"
                      class="btn btn-sm"
                      variant="tonal"
                      :disabled="!canAddMore"
                      @click="addItem"
                    >
                      <ui-icon name="plus" /> {{ $t("add_action") }}
                    </v-btn>

                    <v-btn
                      v-if="localItems.length > 0"
                      color="var(--primary)"
                      class="btn btn-sm text-white"
                      :loading="loading"
                      :disabled="loading"
                      @click="closeAndUpdatePage"
                    >
                      {{ $t("save") }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-slide-x-reverse-transition>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import TipTapInput from "@/components/TipTapInput.vue";
  import { useAppStore } from "@/stores/appStore";
  import wh from "@/helpers/widgetsHelpers.js";
  import { stripHtml } from "@/util/Functions";
  import { VueDraggableNext } from "vue-draggable-next";
  import { debounce } from "lodash-es";

  export default {
    name: "ActionRepeater",

    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default: () => [],
      },

      btnText: {
        type: String,
        default: "Toevoegen",
      },
      show: {
        type: Boolean,
        default: false,
      },
      limit: {
        type: Number,
        default: 1000,
      },
    },
    emits: ["update:modelValue", "update:actions", "update:show"],

    components: {
      TipTapInput,
      draggable: VueDraggableNext,
    },
    data() {
      return {
        titleErrors: [],
        internalDialog: this.show,
        localItems: JSON.parse(JSON.stringify(this.modelValue)),
        loading: false,
        targets_go_to: [
          { title: "Internal link", value: "internal-link" },
          { title: "External Link", value: "external-link" },
        ],
        defaultInteractionActions: [
          {
            type: "show-form-screen",
            icon: "file-text",
            title: "Formulier tonen",
            description: "Toon een formulier scherm",
          },
          {
            type: "open-url",
            icon: "external-link",
            title: "Link openen",
            description: "Open een externe link",
          },
          {
            type: "show-message",
            icon: "message-square",
            title: "Toon bericht",
            description: "Toon een bericht aan de gebruiker",
          },
        ],

        defaultDataActions: [
          {
            type: "add-row",
            icon: "plus-square",
            title: "Item toevoegen",
            description: "Nieuwe rij aanmaken",
          },
          {
            type: "edit-row",
            icon: "edit",
            title: "Bewerk item",
            description: "Bewerk de huidige rij",
          },
          {
            type: "delete-row",
            icon: "trash-2",
            title: "Verwijder item",
            description: "Verwijder de huidige rij",
          },
        ],
      };
    },

    computed: {
      items: {
        get() {
          const items = Array.isArray(this.modelValue) ? this.modelValue : [];
          return items.map((item) => ({
            ...item,
            conditionString: JSON.stringify(item.condition ?? [], null, 2),
            menu: item.menu ?? false,
            action: item.action ?? { type: "", target: "" },
          }));
        },

        set(newItems) {
          const parsedItems = newItems.map((item) => {
            let condition = [];
            try {
              condition = JSON.parse(item.conditionString || "[]");
            } catch {
              condition = [];
            }
            return {
              ...item,
              condition,
            };
          });
          this.$emit("update:modelValue", parsedItems);
        },
      },
      activeWidget() {
        return this.appStore.active.widget;
      },

      collectionFields() {
        return this.appStore.fields;
      },

      appStore() {
        return useAppStore();
      },

      collections() {
        return this.appStore.collections;
      },

      pages() {
        return this.appStore.pages;
      },
      canAddMore() {
        return this.localItems.length < this.limit;
      },
    },

    methods: {
      addAction(action) {
        if (!this.canAddMore) {
          this.$toast.error(`Maximaal ${this.limit} acties toegestaan.`);
          return;
        }
        this.localItems.push({
          title: action.title,
          icon: action.icon,
          action: {
            type: action.type,
            target: "",
          },
          message: "",
          message_icon: "",
          condition: [],
          conditionString: "[]",
        });
        this.emitUpdate();
      },
      clearTitleError(index) {
        const pos = this.titleErrors.indexOf(index);
        if (pos !== -1) {
          this.titleErrors.splice(pos, 1);
        }
        this.emitUpdate();
      },
      toggleMenu(index) {
        this.localItems.forEach((item, i) => {
          item.menu = i === index ? !item.menu : false;
        });
      },
      stripHtml,
      replaceFieldFromDetailPage(type, template) {
        return wh.replaceFieldFromDetailPage(type, template);
      },

      closeAndUpdatePage() {
        this.titleErrors = [];

        const invalidItems = this.localItems.filter((item, index) => {
          if (!item.title || this.stripHtml(item.title).trim() === "") {
            this.titleErrors.push(index);
            return true;
          }
          return false;
        });

        if (invalidItems.length) {
          this.$nextTick(() => {
            this.$toast?.error?.("Geef elke actie een titel om op te slaan.");
          });
          return; // ↩️ sluit dialog niet
        }

        this.loading = true;
        this.emitUpdate();
        this.updatePage();
        this.internalDialog = false;
        this.loading = false;
      },

      updatePage: debounce(function () {
        this.loading = true;
        this.appStore.updateBuilder();

        this.loading = false;
      }, 1000),
      emitUpdate() {
        const parsed = this.localItems.map((item) => {
          let condition = [];
          try {
            condition = JSON.parse(item.conditionString || "[]");
          } catch {
            condition = [];
          }
          return {
            ...item,
            condition,
          };
        });
        this.$emit("update:modelValue", parsed);
        this.updatePage();
      },

      addItem() {
        if (!this.canAddMore) {
          this.$toast.error(`Maximaal ${this.limit} acties toegestaan.`);
          return;
        }
        this.localItems.push({
          title: "",
          icon: "",
          action: {
            type: "",
            target: "",
          },
          message: "",
          message_icon: "",
          condition: [],
          conditionString: "[]",
          menu: false,
        });
        this.emitUpdate();
      },

      removeRow(index) {
        this.localItems.splice(index, 1);
        this.emitUpdate();
        this.updatePage();
      },
      IconForFilterList(itemType) {
        if (typeof itemType !== "string") {
          // console.warn("Ongeldige type voor icon:", itemType);
          return "";
        }
        switch (itemType) {
          case "select":
            return "chevron-down";
          case "checkbox":
            return "square-check";
          case "radio":
            return "circle-check";
          default:
            return "";
        }
      },
    },

    watch: {
      activeWidget: {
        handler(newVal, oldVal) {
          this.updatePage();
        },
        deep: true,
      },
      show(val) {
        this.internalDialog = val;
      },
      internalDialog(val) {
        this.$emit("update:show", val);
      },
      localItems: {
        deep: true,
        handler(newVal) {
          const parsed = newVal.map((item) => {
            let condition = [];
            try {
              condition = JSON.parse(item.conditionString || "[]");
            } catch {
              condition = [];
            }
            return {
              ...item,
              condition,
            };
          });
          this.$emit("update:modelValue", parsed);
        },
      },

      modelValue: {
        handler(newValue) {
          if (!Array.isArray(newValue)) {
            this.localItems = [];
            return;
          }

          this.localItems = newValue.map((item) => ({
            ...item,
            menu: false,
            conditionString: JSON.stringify(item.condition ?? [], null, 2),
            action: item.action ?? { type: "", target: "" },
          }));
        },
        immediate: true,
        deep: true,
      },
      localItems: {
        handler(newItems) {
          // Tel hoe vaak menu = true is
          const openIndex = newItems.findIndex((item) => item.menu === true);

          if (openIndex !== -1) {
            newItems.forEach((item, i) => {
              if (i !== openIndex) item.menu = false;
            });
          }
        },
        deep: true,
      },
    },

    mounted() {
      this.localItems.forEach((item) => (item.menu = false));
    },
  };
</script>
<style>
  .condition-cards {
    max-width: 550px;
    position: relative;

    margin: auto;

    .card-group {
      gap: 25px !important;
      display: flex;
    }

    .ui-card {
      width: 100%;
      margin-bottom: 25px;
    }

    .c-delete-btn {
      position: absolute;
      right: -50px;
    }

    .c-and-or {
      position: relative;

      &:before {
        content: "";
        height: 100px;
        width: 3px;
        position: absolute;
        left: 50%;
        top: -50%;
        transform: translateX(-50%);
        background: #515353;
      }
    }

    .v-divider {
      display: none;
    }
  }

  .add-item-btn {
    position: relative;
    overflow: visible;
    z-index: 1;

    &:before {
      content: "";
      height: 50px;
      width: 3px;
      position: absolute;
      left: 50%;
      top: -25px;
      z-index: -1;

      transform: translateX(-50%);
      background: #24a1c7;
    }
  }

  .action-template-card {
    .action-icon {
      border: 1px solid var(--ui-border-5);
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h6 {
      font-size: 1.6rem;
      letter-spacing: 0;
    }

    p {
      font-size: 1.3rem;
    }
  }
</style>
